import { render, staticRenderFns } from "./SelectorFilters.vue?vue&type=template&id=4c4cd084&scoped=true&"
import script from "./SelectorFilters.vue?vue&type=script&lang=js&"
export * from "./SelectorFilters.vue?vue&type=script&lang=js&"
import style0 from "./SelectorFilters.vue?vue&type=style&index=0&id=4c4cd084&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4cd084",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4cd084')) {
      api.createRecord('4c4cd084', component.options)
    } else {
      api.reload('4c4cd084', component.options)
    }
    module.hot.accept("./SelectorFilters.vue?vue&type=template&id=4c4cd084&scoped=true&", function () {
      api.rerender('4c4cd084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/SelectorFilters.vue"
export default component.exports